//Please add the language resource
const loadingPlan = {
  orderNo:'订单编号',
  schOrderNo:'订单子编号',
  yardCode: '发货DC',
  so: 'SO',
  itrCode:'ITR',
  skuCode:'SKU',
  skuQty:'数量',
  actPickupTime:'提货日期',
  actArriveTime:'到货日期',
  schOrderStatusName:'订单状态',
  expectedDeliveryDate:'期望到货日期',
  customerName: '客户名称',
  customerType:'客户类型',
  orderDate:'订单日期',
  orderMemo:'备注',
  customerCode:'SoldTo',
  customerConsigneeAddrCode:'ShipTo',
  customerConsigneeAddrTel:'联系方式',
  customerConsigneeAddrContact:'联系人',
  customerConsigneeAddr:"地址",

  truckNo: '车牌号',
  driverNo: '司机',
  licenseNumber: '驾驶证号',
  contactNumber:'联系电话',
  appointmentTime: '预约时间',
  yardName: '发货DC(堆场名称)',
  stockDate: '预计到库时间',
  carrierNo: '运输商',
  loadVolume: '装载量(M³)',
  loadWeight: '载重量(T)',
  isBox:'是否箱车',
  truckType: '车辆类型',
  ownership:'车辆属权',
  driverName:'司机姓名',
  driverTelephone:'司机电话',
  driverLicense: '驾驶证号码',

  planShipTime: '预计提货日期',
  msg:{
  }
};
export default loadingPlan



// WEBPACK FOOTER //
// ./src/page/transport/loadingPlan/lang/loadingPlan.en.js